import getActionTypes from './getActionTypes';

export default function getActionCreators(reduxActionName: string): any {
  const { SET_PARAMS_FOR_REQUEST, REQUEST_READY, REQUEST_START, REQUEST_SUCCEEDED, REQUEST_FAILED, CLEAR_DATA } = getActionTypes(
    reduxActionName,
  );

  return {
    setParamsForRequest: (paramsForRequest: any) => ({
      type: SET_PARAMS_FOR_REQUEST,
      paramsForRequest,
    }),

    requestReady: () => ({
      type: REQUEST_READY,
    }),

    requestStart: () => ({
      type: REQUEST_START,
    }),

    requestSuccess: (response: any) => ({
      type: REQUEST_SUCCEEDED,
      ...response,
    }),

    requestFail: (response: any) => ({
      type: REQUEST_FAILED,
      ...response,
    }),

    clearData: () => ({
      type: CLEAR_DATA,
    }),
  };
}
